import React, { Component } from 'react';
import { Consumer } from 'store/createContext';
import {
  Container,
  Card,
  Title,
  Option,
  // BtnGroup,
  ProgressContainer,
  Partner,
  Name,
  Price,
  Sub,
  TextInput,
  Btn,
  StyledField,
  StyledErrorField,
} from './survey.css';
import { Formik, Form } from 'formik';
import Yup from 'yup';
import axios from 'axios';
import ReactGA from 'react-ga';
import { signUp } from '../../constants/api';

import './geosuggest.css';
import HowSoon from './cards/howSoon';
import SalesMethod from './cards/salesMethod';
import WhereIsYourHome from './cards/whereIsYourHome';
import ValueEstimate from './cards/valueEstimate';
import InitialEstimate from './cards/initialEstimate';
import Partners from './cards/partners';

class Survey extends Component {
  state = {
    progress: 0,
    noAddress: false,
    estimate: false,
    submitted: false,
  };

  nextStep = () => {
    this.setState(state => ({
      progress: state.progress + 1,
    }));
  };

  noAddress = () => {
    this.setState(state => ({
      noAddress: true,
      progress: state.progress + 1,
    }));
  };

  prevStep = () => {
    this.setState(state => ({
      progress: state.progress - 1,
    }));
  };

  threeCompanyEstimate = () => {
    this.setState(state => ({
      estimate: true,
      progress: state.progress + 1,
    }));
  };

  render() {
    const { noAddress, estimate, submitted } = this.state;
    return (
      <Consumer>
        {({
          progress,
          setHowSoon,
          setSalesMethod,
          setAddress,
          address,
          goFwd,
          userEmail,
          setUserEmail,
          queryParams,
          howSoon,
          salesMethod,
          userId,
          partners,
          setPartners,
          submitCampaign,
        }) => (
          <Container
            name="survey"
            small={
              queryParams && queryParams.small && queryParams.small === 'true'
            }
          >
            {queryParams && queryParams.v === '2' ? (
              <ProgressContainer step={progress} total={9}>
                <SalesMethod
                  queryParams={queryParams}
                  setSalesMethod={setSalesMethod}
                  nextStep={1}
                />

                <WhereIsYourHome
                  setAddress={setAddress}
                  address={address}
                  nextStep={2}
                  goFwd={goFwd}
                  background={true}
                />

                <HowSoon
                  queryParams={queryParams}
                  setHowSoon={setHowSoon}
                  nextStep={3}
                />

                <InitialEstimate
                  queryParams={queryParams}
                  partners={partners}
                  setPartners={setPartners}
                  nextStep={2}
                  count={1}
                />

                <Partners submitCampaign={submitCampaign} goFwd={goFwd} />

                <Card background>
                  <Title>Thank You!</Title>
                  <Sub>We will be in touch soon.</Sub>
                </Card>

                {!estimate ? (
                  <Card>
                    <Title>Get Estimate</Title>

                    <div style={{ margin: '30px 0' }}>
                      <Partner>
                        <Name>Homie</Name>
                        <Price>$100k</Price>
                      </Partner>
                      <Partner>
                        <Name>Rex Real Estate</Name>
                        <Price blur>$120k</Price>
                      </Partner>
                      <Partner>
                        <Name>Century 21</Name>
                        <Price blur>$100k</Price>
                      </Partner>
                    </div>

                    <Option onClick={this.nextStep}>
                      Sign Up For All Offers
                    </Option>
                    <Option onClick={this.noAddress} skip>
                      Skip
                    </Option>
                  </Card>
                ) : (
                  <Card>
                    <Title>Partner Referall</Title>

                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                  </Card>
                )}

                {noAddress ? (
                  <Card>
                    <Title>No Address</Title>

                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                  </Card>
                ) : (
                  <Card background>
                    <Title>Get Your Estimate</Title>
                    <Sub>Our service is 100% free. No Strings Attached.</Sub>

                    <TextInput type="text" placeholder="Enter Your Email" />
                    <Btn>Sign Up</Btn>
                  </Card>
                )}
              </ProgressContainer>
            ) : queryParams && queryParams.full ? (
              <ProgressContainer step={progress} total={9}>
                <HowSoon
                  queryParams={queryParams}
                  setHowSoon={setHowSoon}
                  nextStep={1}
                />

                <SalesMethod
                  queryParams={queryParams}
                  setSalesMethod={setSalesMethod}
                  nextStep={2}
                />

                <WhereIsYourHome
                  setAddress={setAddress}
                  address={address}
                  nextStep={3}
                  goFwd={goFwd}
                  background={true}
                />

                <InitialEstimate
                  queryParams={queryParams}
                  partners={partners}
                  setPartners={setPartners}
                  nextStep={2}
                />

                <Partners submitCampaign={submitCampaign} goFwd={goFwd} />

                <Card background>
                  <Title>Thank You!</Title>
                  <Sub>We will be in touch soon.</Sub>
                </Card>

                {!estimate ? (
                  <Card>
                    <Title>Get Estimate</Title>

                    <div style={{ margin: '30px 0' }}>
                      <Partner>
                        <Name>Homie</Name>
                        <Price>$100k</Price>
                      </Partner>
                      <Partner>
                        <Name>Rex Real Estate</Name>
                        <Price blur>$120k</Price>
                      </Partner>
                      <Partner>
                        <Name>Century 21</Name>
                        <Price blur>$100k</Price>
                      </Partner>
                    </div>

                    <Option onClick={this.nextStep}>
                      Sign Up For All Offers
                    </Option>
                    <Option onClick={this.noAddress} skip>
                      Skip
                    </Option>
                  </Card>
                ) : (
                  <Card>
                    <Title>Partner Referall</Title>

                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                  </Card>
                )}

                {noAddress ? (
                  <Card>
                    <Title>No Address</Title>

                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                  </Card>
                ) : (
                  <Card background>
                    <Title>Get Your Estimate</Title>
                    <Sub>Our service is 100% free. No Strings Attached.</Sub>

                    <TextInput type="text" placeholder="Enter Your Email" />
                    <Btn>Sign Up</Btn>
                  </Card>
                )}
              </ProgressContainer>
            ) : (
              <ProgressContainer step={progress} total={7}>
                <HowSoon
                  queryParams={queryParams}
                  setHowSoon={setHowSoon}
                  nextStep={1}
                />
                <SalesMethod
                  queryParams={queryParams}
                  setSalesMethod={setSalesMethod}
                  nextStep={2}
                />

                <Card background>
                  {submitted ? (
                    <>
                      <Title>Thank You!</Title>
                      <Sub>We will be in touch soon.</Sub>
                    </>
                  ) : (
                    <>
                      <Title>Get Your Estimate</Title>
                      <Sub>Our service is 100% free. No Strings Attached.</Sub>
                    </>
                  )}

                  {!submitted && (
                    <Formik
                      initialValues={{ email: '' }}
                      onSubmit={async values => {
                        const result = await axios.post(signUp('dev'), {
                          howSoon,
                          salesMethod,
                          userId,
                          email: values.email,
                        });

                        if (result.status === 200) {
                          this.setState({
                            submitted: true,
                          });

                          ReactGA.event({
                            category: 'Sign Up Flow',
                            action: 'Submitted',
                          });
                        }
                      }}
                      validationSchema={Yup.object().shape({
                        email: Yup.string()
                          .email()
                          .required('Required'),
                      })}
                      render={({ isSubmitting }) => (
                        <Form>
                          <StyledField
                            type="email"
                            name="email"
                            placeholder="Enter Your Email"
                          />
                          <StyledErrorField name="email" />
                          <Btn type="submit" disable={isSubmitting}>
                            {isSubmitting ? 'Submitting' : 'Sign Up'}
                          </Btn>
                        </Form>
                      )}
                    />
                  )}
                </Card>

                <WhereIsYourHome
                  setAddress={setAddress}
                  address={address}
                  nextStep={3}
                  goFwd={goFwd}
                />

                <ValueEstimate
                  userEmail={userEmail}
                  setUserEmail={setUserEmail}
                  nextStep={4}
                  goFwd={goFwd}
                />

                {!estimate ? (
                  <Card>
                    <Title>Get Estimate</Title>

                    <div style={{ margin: '30px 0' }}>
                      <Partner>
                        <Name>Homie</Name>
                        <Price>$100k</Price>
                      </Partner>
                      <Partner>
                        <Name>Rex Real Estate</Name>
                        <Price blur>$120k</Price>
                      </Partner>
                      <Partner>
                        <Name>Century 21</Name>
                        <Price blur>$100k</Price>
                      </Partner>
                    </div>

                    <Option onClick={this.nextStep}>
                      Sign Up For All Offers
                    </Option>
                    <Option onClick={this.noAddress} skip>
                      Skip
                    </Option>
                  </Card>
                ) : (
                  <Card>
                    <Title>Partner Referall</Title>

                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                  </Card>
                )}

                {noAddress ? (
                  <Card>
                    <Title>No Address</Title>

                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                    <Partner>
                      <Name>Homie</Name>
                      <Price>$100k</Price>
                    </Partner>
                  </Card>
                ) : (
                  <Card background>
                    <Title>Get Your Estimate</Title>
                    <Sub>Our service is 100% free. No Strings Attached.</Sub>

                    <TextInput type="text" placeholder="Enter Your Email" />
                    <Btn>Sign Up</Btn>
                  </Card>
                )}
              </ProgressContainer>
            )}
          </Container>
        )}
      </Consumer>
    );
  }
}

export default Survey;
